import InfoRow from "../InfoRow";
import PeopleList from "../PeopleList";
import { capitalize } from "@material-ui/core";
import { useAppContext } from "../../_context";
import LocationInfo from "./LocationInfo";

const CommonInfo = ({ entity }) => {
  const [{ tx }] = useAppContext();

  const matchType = (nPlayers) => {
    switch (nPlayers) {
      case 2:
      case "single":
        return tx["Singles"];

      case 4:
      case "double":
      case "doubles":
        return tx["Doubles"];
    }

    return tx["Social"];
  };

  return (
    <>
      {entity.players.length ? (
        <InfoRow icon="players" label={tx["Players"]}>
          <PeopleList people={entity.players} />
        </InfoRow>
      ) : null}
      <InfoRow icon="tennis-ball" label={tx["Sport"]}>
        {capitalize(tx[entity.sport] || entity.sport)}
      </InfoRow>
      <InfoRow icon="bars" label={tx["Match level"]}>
        {entity.level.map((label, index) => {
          return (
            <span key={index}>
              {capitalize(tx[label] || label) +
                (index + 1 === entity.level.length ? "" : ", ")}
            </span>
          );
        })}
      </InfoRow>
      <InfoRow icon="four-circles" label={tx["Match type"]}>
        {matchType(entity.type)}
      </InfoRow>
      <LocationInfo location={entity.location} />
    </>
  );
};

export default CommonInfo;
